<template>
    <grid v-on="listeners" v-bind="attrs" ref="cardGridGrid" :with-space="false" :offset-top="0" gridTheme="ag-theme-alpine-dashboard">
        <slot></slot>
    </grid>
</template>

<script>
    import Grid from '../grid/grid.vue';

    export default {
        name: 'CardGrid',
        components: {
            Grid,
        },
        computed: {
            attrs() {
                const { state, ...attrs } = this.$attrs;
                return attrs;
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
        methods: {
            refreshDataSource() {
                this.$refs.cardGridGrid.refreshDataSource();
            },
            refreshServerSide() {
                this.$refs.cardGridGrid.refreshServerSide();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    :deep(.ag-header) {
        border-bottom: none !important;
    }

    :deep(.ag-header-row) {
        color: $secondary !important;
        font-weight: 400 !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px;
        margin-bottom: 1rem !important;
    }

    :deep(.ag-row.ag-row-last) {
        border-bottom-style: none;
    }
</style>
